'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { useAlertBoxContext } from './alert-box.context.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const AlertBoxDismissButton = renderWithRef('AlertBoxDismissButton', null, (o, c)=>{
    useDeprecatedProps('AlertBoxDismissButton', o, [
        {
            propName: 'visuallyHiddenLabel',
            instructions: 'Use `accessibleText` instead'
        }
    ]);
    let p = new Set([
        'swan-alert-box-close-button'
    ]), { onRequestDismiss: u } = useAlertBoxContext(), { visuallyHiddenLabel: a, accessibleText: b, children: f, onClick: m } = o, _ = _object_without_properties(o, [
        "visuallyHiddenLabel",
        "accessibleText",
        "children",
        "onClick"
    ]), d = null != b ? b : a;
    return jsxs(RenderComp, {
        root: "button",
        forwardedRef: c,
        classNames: p,
        props: _object_spread({}, _, {
            onClick: composeEventHandlersUtil(m, ()=>'function' == typeof u && u())
        }),
        children: [
            null != d && jsx(VisuallyHidden, {
                children: d
            }),
            f
        ]
    });
});

export { AlertBoxDismissButton };
